// Copyright (c) 2017 Deere & Company

const allowedFormatKeys = ['1', '2', '3', '4', '5', '6'];

const dateFormats = {
    1: 'D.M.YYYY',
    2: 'M/D/YYYY',
    3: 'M-D-YYYY',
    4: 'YYYY.M.D',
    5: 'YYYY/M/D',
    6: 'YYYY-M-D',
};

export const getDateFormat = (formatKey) => formatKey && allowedFormatKeys.includes(formatKey) ? dateFormats[formatKey] : 'M/D/YYYY';
